// extracted by mini-css-extract-plugin
module.exports = {"container":"eeb6c9d23e--container--PXAP9","close-icon":"eeb6c9d23e--close-icon--f2Je1","text":"eeb6c9d23e--text--BXOyE","buttons":"eeb6c9d23e--buttons--wFVrE"};